ty<template>
    <div class="q-pa-md">
        <div class="q-gutter-md text-left">
            <div class="row">
                <div class="col">
                    <h6>Saldo</h6>
                    <p>
                        {{
                            new Intl.NumberFormat(currency.definition['locale'], {
                                style: 'currency',
                                currency: currency.key,
                            }).format(accountBalance.money)
                        }}
                    </p>
                </div>
                <div class="col">
                    <h6>Pontos</h6>
                    <p>{{ accountBalance.points }}</p>
                </div>
                <div class="col-grow text-right">
                    <q-btn
                        color="secondary"
                        label="Adicionar Fundos"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from '@/store'

export default {
    name: 'CurrentAccount',

    data() {
        return {
            accountBalance: {
                money: 300000.00,
                points: 1000
            }
        }
    },

    computed: {
        locale() {
            return store.getters['locale/currentLocale']
        },

        currency() {
            return store.getters['currency/currentCurrency']
        },
    }
}
</script>
